import { ContentType } from "./http-client";

export class NotaryAuthorization {
  constructor(http) {
    this.http = http;
  }

  get = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/notary-authorization`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  initiate = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/notary-authorization/initiate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  attachDeed = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/notary-authorization/attach-deed`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  callback = (rentalId, data, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/notary-authorization/callback`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  webhook = (data, params = {}) =>
    this.http.request({
      path: `/api/rentals/notary-authorization/webhook`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  getEvictionPack = (rentalId, params = {}) =>
    this.http.request({
      path: `/api/rentals/${rentalId}/notary-authorization/eviction-pack`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
